import React from 'react';
import safeReload from '../../safeReload';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Recover from the crash, but only reload once the server is reachable —
      // reloading on weak/no internet would leave the screen blank.
      setTimeout(() => safeReload(), 3000);
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>מרענן דף...</h2>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;